import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../../core/service/layout.service';
import { ReviewService } from '../service/review.service';
import { ReviewAllocationSplitType } from '../model/RevalAllocationSplitType';

@Component({
    templateUrl: './reviewCohortCreate.component.html',
    selector: 'app-review-cohort-create',
    styleUrls: ['../list.scss', './review.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class ReviewCohortCreateComponent implements OnInit{

  constructor(public layout: LayoutService, private service: ReviewService) { }

  ngOnInit(): void {
    }

  generating = false;
  cohortSize: number | '' = '';
  reviewDeadline = '';
  noResults = false;

  @Output() created = new EventEmitter();

 //SearchOption = SearchOption;
  searchBy = ReviewAllocationSplitType.Default;
  ReviewAllocationSplitType = ReviewAllocationSplitType;
  PharmacistAllocation: number | '' = '';
  TechnicianAllocation: number | '' = '';
 
  
  get inputByNumber() {
    return this.searchBy === ReviewAllocationSplitType.Absolute;
  }

  get inputByPercentage() {
    return this.searchBy === ReviewAllocationSplitType.Percentage;
  }

  get inputByDefault() {
    return this.searchBy === ReviewAllocationSplitType.Default;
  }
  get NumberOfRegistrantsAlloted() {
    return (this.inputByNumber && (this.PharmacistAllocation ==='' || this.TechnicianAllocation ===''));
  }
  get NumberOfRegistrantsLesserThanAllocated() {
    return typeof this.PharmacistAllocation === 'number' &&
      typeof this.TechnicianAllocation === 'number' &&
      typeof this.cohortSize === 'number' &&
      this.PharmacistAllocation + this.TechnicianAllocation !== this.cohortSize;
  }
  get NumberOfRegistrantsAllotedByPercent() {
    return (this.inputByPercentage && (this.PharmacistAllocation ==='' || this.TechnicianAllocation ===''));
  }

  generate() {
    if (typeof this.cohortSize !== 'number' || !this.reviewDeadline) {
      return;
    }

    this.generating = true;
    this.service.createReviewCohort(this.cohortSize, this.reviewDeadline, this.PharmacistAllocation,
      this.TechnicianAllocation, this.searchBy).subscribe(() => {
      this.generating = false;
      this.created.emit();
    },
      error => {
        this.generating = false;
        this.noResults = (error.status === 400 || error.status === 404 || error.status === 500);
      });
  }

  setFocus() {
     this.PharmacistAllocation = '';
     this.TechnicianAllocation = '';
  }


  updateSetting(event: { value: number }) {
    if(event.value===0){
this.PharmacistAllocation = '';
this.TechnicianAllocation = '';
    }else{
      this.PharmacistAllocation = event.value;
      this.TechnicianAllocation = 100 - this.PharmacistAllocation;
    }
   
  }


}